import Vue from 'vue';
import jwt from 'jsonwebtoken';
import {store} from '../store.js';

export default {
    eventTypes: {
        likeOutfit: "like_outfit",
        rejectOutfit: "reject_outfit",
        onboardingLikeOutfit: "onboarding_like_outfit",
        onboardingRejectOutfit: "onboarding_reject_outfit"
    },

    options: {
        authTokenUrl: "https://www.googleapis.com/oauth2/v4/token",
        authScope: "https://www.googleapis.com/auth/pubsub",
        pubsubBaseUrl: "https://content-pubsub.googleapis.com/v1",
        pubsubLSTokenCreatedAtKey: "gpubsub-token-created",
        pubsubLSTokenKey: "gpubsub-token",
        pubsubTokenLifetime: 3600
    },

    localEventQueue: [],

    trackEvent(eventType, eventData) {
        console.log(eventType, eventData);
        return;
        this.getPubSubAuthToken()
            .then((pubSubAuthToken) => {
                if(pubSubAuthToken) {
                    eventData = {...eventData, ...this.getEventDataFromState(store.state)};
                    let messageData = {
                        event: eventType,
                        data: eventData
                    }
                    let params = {
                        messages: [{
                            data: btoa(JSON.stringify(messageData))
                        }]
                    };

                    Vue.http.post(
                        this.getPubSubPublishUrl(),
                        params,
                        {
                            headers: {
                                "Authorization": "Bearer " + pubSubAuthToken
                            }
                        }
                    )
                    .then((response) => {})
                    .catch((error) => {});
                }
            });

        switch(eventType) {
            case this.eventTypes.likeOutfit:
            case this.eventTypes.rejectOutfit:
            case this.eventTypes.onboardingLikeOutfit:
            case this.eventTypes.onboardingRejectOutfit:
                if(typeof this.localEventQueue[eventType] === 'undefined') {
                    this.localEventQueue[eventType] = [];
                }
                this.localEventQueue[eventType].push({
                    eventType: eventType,
                    eventData: eventData
                });
                break;
            default:
                break;
        }
    },

    getEventDataFromState(state) {
        let filters = state.filters,
            user = state.auth.user,
            occasionFilter = null,
            seasonFilter = null,
            priceFilter = null,
            currentTime = new Date();

        for(let idx in filters.selectedFilters) {
            let currentFilter = filters.selectedFilters[idx];
            if(currentFilter) {
                if(currentFilter.product_option_token == 'occasion') {
                    occasionFilter = filters.selectedFilters[idx].product_option_value_title;
                }
                if(currentFilter.product_option_token == 'season') {
                    seasonFilter = filters.selectedFilters[idx].product_option_value_title;
                }
                if(
                    (currentFilter.product_option_value_min || 0) > 0 &&
                    (currentFilter.product_option_value_max || 0) > 0
                ) {
                    priceFilter = filters.selectedFilters[idx].product_option_value_title;
                }
            }
        }

        return {
            userId: user.user_id || null,
            occasionFilter: occasionFilter,
            seasonFilter: seasonFilter,
            priceFilter: priceFilter,
            dateTime: currentTime.toUTCString()
        }
    },

    getPubSubCredentials(config) {

    },

    getPubSubPublishUrl() {
        let pubsubAuthConfig = app.$store.getters['config/getPubSubJson'];
        if(pubsubAuthConfig) {
            return this.options.pubsubBaseUrl + '/projects/' + pubsubAuthConfig.project_id + '/topics/' + pubsubAuthConfig.topic + ':publish?alt=json';
        }

        return '';
    },

    getPubSubAuthToken() {
        let pubsubAuthConfig = app.$store.getters['config/getPubSubJson'],
            localStorage = this.localStorage();

        if(localStorage && pubsubAuthConfig) {
            let gpubsubTokenCreatedAt = parseInt(localStorage.getItem(this.options.pubsubLSTokenCreatedAtKey)),
                gpubsubToken = localStorage.getItem(this.options.pubsubLSTokenKey),
                currentTime = Math.floor(Date.now() / 1000);

            if(gpubsubToken && ((gpubsubTokenCreatedAt + this.options.pubsubTokenLifetime) > currentTime)) {
                return Promise.resolve(gpubsubToken);
            }

            let params = {
                'iss': pubsubAuthConfig.client_email,
                'sub': pubsubAuthConfig.client_email,
                'aud': this.options.authTokenUrl,
                'iat': currentTime,
                'exp': currentTime + this.options.pubsubTokenLifetime,
                'scope': this.options.authScope
            };
            
            let options = {
                algorithm: 'RS256',
                header: {
                    'kid': pubsubAuthConfig.private_key_id,
                    'typ': 'JWT',
                    'alg': 'RS256',
                },
            };

            let selfSignedToken = jwt.sign(params, pubsubAuthConfig.private_key, options);
            return Vue.http.post(
                this.options.authTokenUrl,
                {
                    grant_type: "urn:ietf:params:oauth:grant-type:jwt-bearer",
                    assertion: selfSignedToken
                }
            )
            .then((response) => {
                gpubsubToken = response.body.access_token;
                localStorage.setItem(this.options.pubsubLSTokenKey, gpubsubToken);
                localStorage.setItem(this.options.pubsubLSTokenCreatedAtKey, currentTime);

                return Promise.resolve(gpubsubToken);
            });
        }

        return Promise.resolve(null);
    },

    localStorage() {
        try {
            return window.localStorage;
        } catch (e) {}

        return null;
    },

    getAndResetLatestLikedOutfits() {
        let latestLikes = [];
        if(Array.isArray(this.localEventQueue[this.eventTypes.likeOutfit])) {
            for(let i = 0; i < this.localEventQueue[this.eventTypes.likeOutfit].length; i++) {
                latestLikes.push(this.localEventQueue[this.eventTypes.likeOutfit][i].eventData.outfitId);
            }
        }

        this.localEventQueue[this.eventTypes.likeOutfit] = [];

        return latestLikes;
    },

    getAndResetLatestRejectedOutfits() {
        let latestRejects = [];
        if(Array.isArray(this.localEventQueue[this.eventTypes.rejectOutfit])) {
            for(let i = 0; i < this.localEventQueue[this.eventTypes.rejectOutfit].length; i++) {
                latestRejects.push(this.localEventQueue[this.eventTypes.rejectOutfit][i].eventData.outfitId);
            }
        }

        this.localEventQueue[this.eventTypes.rejectOutfit] = [];

        return latestRejects;
    },

    filterInteractedOutfits(outfits) {
        const interactedOutfits = this.localEventQueue[
            this.eventTypes.rejectOutfit
        ].concat(this.localEventQueue[this.eventTypes.likeOutfit])

        return outfits.filter((outfit) =>
            interactedOutfits.every(
                ({ eventData }) => eventData.outfitId !== outfit.outfit_id
            )
        );
    },
}
